export { default } from './InputAdornment';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/InputAdornment/index.js
// module id = 336
// module chunks = 0